<template>
  <div>
    <v-container>
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg">{{ area.transName }} - {{ $t('Кварталы') }}</h1>
      <div class="workroom-pg">
        <div class="bgw-pdg-20 observer-pg">
          <div class="add-npa-row">
            <QuarterAdd
              :areaId="area.id"
            >
              {{ $t('Добавить квартал') }}
            </QuarterAdd>
          </div>
          <div class="table-overflow">
            <table class="table-full">
              <thead>
              <tr>
                <td class="num-td">№</td>
                <td class="full-name-td">{{ $t('Номер') }}</td>
                <td class="full-name-td">{{ $t('Площадь') }}</td>
                <td class="full-name-td">{{ $t('Выделы') }}</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(quarter, i) in area.quarters" :key="quarter.id">
                <td class="num-td">{{ ++i }}</td>
                <td class="full-name-td">
                  <QuarterAdd
                    :areaId="area.id"
                    :quarterEdit="true"
                    :quarterId="quarter.id"
                  >
                    {{ quarter.number }} <span class="edit-icon"></span>
                  </QuarterAdd>
                </td>
                <td class="full-name-td">
                  {{ quarter.square }}
                </td>
                <td class="full-name-td">
                  <router-link
                    tag="a"
                    :to="{ name: 'highlights', params: { id: quarter.id } }"
                  >
                    {{ $t('Выделы') }}
                  </router-link>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <v-pagination
            v-model="page"
            :length="paginationData.pageCount"
            total-visible="10"
          />
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Quarter from '@/model/quarter'
import QuarterAdd from '@/components/oopt/QuarterAdd'

export default {
  components: {
    QuarterAdd
  },
  data: () => ({
    area: {},
    oopt: {},
    paginationData: {},
    breadcrumbs: [],
    page: 1
  }),
  watch: {
    $route: 'fetchData',
    page () {
      this.fetchData()
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Quarter.list(this.$route.params.id, this.page)
        .then((response) => {
          this.area = { ...response.data.area }
          this.oopt = { ...response.data.oopt }
          this.paginationData = { ...response.data.paginationData }
          this.breadcrumbs = [
            {
              text: this.$i18n.t('Главная'),
              disabled: false,
              href: '/'
            },
            {
              text: this.$i18n.t('Рабочий кабинет'),
              disabled: false,
              href: '/my-organization'
            },
            {
              text: `${this.oopt.transName} - ${this.$i18n.t('Участки')}`,
              disabled: false,
              href: `/plots/${this.oopt.id}`
            },
            {
              text: this.area.transName + ' - ' + this.$i18n.t('Кварталы'),
              disabled: true
            }
          ]
          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
        })
    }
  }
}
</script>
